import React from "react";
import Hero from "./Home/Hero";
import Services from "./Home/Services";
import WhyChooseUs from "./Home/WhyChooseUs";
import Portfolio from "./Home/Portfolio";
import Testimonials from "./Home/Testimonials";
import Contact from "./Home/Contact";

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <WhyChooseUs />
      <Portfolio />
      <Testimonials />
      <Contact />
    </>
  );
};

export default Home;
